import { Component, createApp, h } from 'vue';
import { ConfigProvider } from 'ant-design-vue';
import zhCN from 'ant-design-vue/es/locale/zh_CN';

export function createModal(
  options: { params: Object; component: Component },
  otherOptions?: {
    beforeMount?: Function;
  }
) {
  const parent = document.createElement('div');
  return new Promise<void>((resolve) => {
    const app = createApp({
      render() {
        return h(
          ConfigProvider,
          {
            locale: zhCN,
          },
          [
            h(options.component, {
              visible: true,
              ...(options.params || {}),
              'onUpdate:visible': async (v) => {
                await options.params?.['onUpdate:visible']?.(v);
                if (!v) {
                  app.unmount();
                  document.body.removeChild(parent);
                  resolve();
                }
              },
            }),
          ]
        );
      },
    });

    otherOptions?.beforeMount?.(app);
    app.mount(parent);
    document.body.appendChild(parent);
  });
}
